import {
    serializable,
    DynamicFormControlLayout,
    DynamicInputModel,
    DynamicInputModelConfig,
} from "@ng-dynamic-forms/core";
import { COMPONENT_MODE, COMPONENT_UI } from '../../workflow-components.models';
import { Model_WorkflowComponent } from 'src/app/app.models';
  
export interface InputGridFunctionsFiltersModelConfig extends DynamicInputModelConfig {
	componentMode: COMPONENT_MODE;
}
  
export class InputGridFunctionsFiltersModel extends DynamicInputModel {
	@serializable() readonly type: string = 'input_grid_functions_filters'; 
	componentMode: COMPONENT_MODE;
	componentUI: COMPONENT_UI;

	constructor(config: InputGridFunctionsFiltersModelConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
		this.componentMode = config.componentMode;
		this.componentUI = COMPONENT_UI.IONIC;
	}

	static initModel(_component: Model_WorkflowComponent): InputGridFunctionsFiltersModel {
		const formModel = new InputGridFunctionsFiltersModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
			value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE !== undefined ? _component.IS_VISIBLE === false : false,
			validators: _component.CUSTOM_VALIDATORS,
			componentMode: _component.COMPONENT_MODE,
			additional: _component,
			relations: _component.RELATIONS,
		});
		return formModel;
	}
}
  